// Legacy URL map from the previous WordPress/Wix sites (sourced from the
// Wayback Machine + GSC coverage report). Client-side redirects preserve
// old backlinks and clear "excluded by noindex" entries in Search Console.
const LEGACY_REDIRECTS = {
  // Old homepage aliases
  '/home': '/',
  // Company pages
  '/about-us': '/about',
  '/about-you': '/about',
  '/contact': '/#contact',
  '/contact-us': '/#contact',
  '/privacy-policy-2': '/privacy-policy',
  // Old solution/feature pages → solutions section
  '/solutions': '/#solutions',
  '/solutions-integrations': '/integrations',
  '/estimating': '/#solutions',
  '/order-processing': '/#solutions',
  '/order-processing-1': '/#solutions',
  '/production-control': '/#solutions',
  '/stock-control': '/#solutions',
  '/warehousing': '/#solutions',
  '/data-reporting': '/#solutions',
  '/imprint-dashboard': '/#solutions',
  '/imprint-desktop': '/#solutions',
  '/report-genearator': '/#solutions',
  '/sfdc-machine-monitoring': '/#solutions',
  // Old blog index/category/tag URLs → resources section
  '/blog': '/resources',
  '/events-page': '/resources',
  // Old posts with direct new equivalents
  '/gcps-machine-monitoring-project': '/resources/gcp-machine-monitoring-project',
  '/post/gcp-s-machine-monitoring-project': '/resources/gcp-machine-monitoring-project',
  '/simply-cartons-imprint-mis': '/resources/simply-cartons-imprint-mis',
  '/post/simply-cartons-and-imprint-mis': '/resources/simply-cartons-imprint-mis',
  '/imprints-new-automation-engine-integration-goes-live': '/resources/automation-engine-integration',
  '/post/imprint-s-new-automation-engine-integration-goes-live': '/resources/automation-engine-integration',
  // Old posts without a new equivalent → resources section
  '/imprint-and-latcham-a-partnership': '/resources',
  '/post/imprint-and-latcham-a-partnership': '/resources',
  '/importance-of-a-project-leader-when-implementing-a-mis-system': '/resources',
  '/post/importance-of-a-project-leader-when-implementing-an-mis-system': '/resources',
  '/take-control-of-costs-in-real-time': '/resources',
  '/post/take-control-of-costs-in-real-time': '/resources',
  '/top-five-tips-for-starting-the-process-of-choosing-an-mis-system': '/resources',
  '/post/top-5-tips-for-starting-the-process-of-choosing-an-mis-system': '/resources',
  '/top-five-tips-why-an-mis-project-fails': '/resources',
  '/post/top-5-tips-why-an-mis-project-fails': '/resources',
  '/post/covid-19-imprint-s-response': '/resources',
  '/post/ready-for-print-to-punchback': '/resources',
};

// Wildcard prefixes (old category/tag archives)
const LEGACY_PREFIXES = [
  ['/category/', '/resources'],
  ['/resources/categories/', '/resources'],
  ['/resources/hashtags/', '/resources'],
  ['/resources/page/', '/resources'],
];

export function resolveLegacyRedirect(pathname) {
  const clean = pathname.replace(/\/+$/, '').toLowerCase() || '/';
  if (LEGACY_REDIRECTS[clean]) return LEGACY_REDIRECTS[clean];
  // Old WordPress RSS endpoints (/comments/feed/, /{post}/feed/)
  if (clean === '/feed' || clean.endsWith('/feed')) return '/resources';
  const prefix = LEGACY_PREFIXES.find(([p]) => clean.startsWith(p));
  return prefix ? prefix[1] : null;
}
